import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IFundraiser } from '../../fundraiser/models/fundraiser.model';
import { IUser } from '../../shared/models';
import { AuthService, EventsService, FundraiserService, SignupService, UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-follow-campaign',
  templateUrl: './follow-campaign.component.html',
  styleUrls: ['./follow-campaign.component.scss']
})
export class FollowCampaignComponent implements OnInit, OnDestroy {

  @Input() fundraiser: IFundraiser;
  @Input() isFollowed;
  @ViewChild('captchaRef') captchaRef;
  loginForm: FormGroup;
  type;
  user: IUser;
  isLoading = false;
  number;
  payload;
  step = 'step_1';
  donor;
  dialogRef: MatDialogRef<any>;
  subs: Subscription[] = [];

  constructor(
    public util: UtilService,
    private vars: VariablesService,
    private events: EventsService,
    private auth: AuthService,
    private signupService: SignupService,
    private fundraiserService: FundraiserService,
    public dialog: MatDialog,
    public sheet: MatBottomSheet
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.subs.push(this.vars.userData.subscribe(res => this.user = res));
  }

  initForm() {
    this.loginForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.pattern(/^[a-z ,.'-]+$/i)]),
      mobile: new FormControl('', Validators.required),
      captcha: new FormControl('', Validators.required),
      email: new FormControl('', [
        Validators.required, Validators.pattern(/^[_a-zA-Z0-9]+(\.[_a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,4})$/)
      ]),
    });
  }

  openPopup(template) {
    this.events.sendSystemEvent({
      'eventName': 'follow_campaign_click',
      'info_3': 'impact',
      'page_name': this.vars.pageName,
      'event_type_id': this.vars.fundraiser.id
    }).subscribe(_ => _);
    if (this.user) {
      this.followCampaign(this.user.id);
      return false;
    }
    if (this.util.isMobile()) {
      this.type = 'sheet';
      const bottomSheetRef = this.sheet.open(template, {
        panelClass: 'bottom-sheet-container-extented',
      });
      bottomSheetRef.afterOpened().subscribe(() => this.initCaptcha());
      bottomSheetRef.afterDismissed().subscribe(() => this.isLoading = false);
    } else {
      this.type = 'dialog';
      this.dialogRef = this.dialog.open(template, {
        width: '544px',
        height: '500px',
        panelClass: 'request-sent',
      });
      this.dialogRef.afterOpened().subscribe(() => this.initCaptcha());
      this.dialogRef.afterClosed().subscribe(() => {
        this.isLoading = false;
      });
    }
  }

  submitForm() {
    if (this.loginForm.valid) {
      this.payload = {
        full_name: this.loginForm.get('name').value,
        email_id: this.loginForm.get('email').value,
        email: this.loginForm.get('email').value,
        extension: this.number.extn,
        phone_1: this.loginForm.get('mobile').value,
        password: Math.random().toString(36).slice(2, 10),
        invisible_recaptcha: true,
        user_type: 'individual',
        registration_source: 'direct',
        is_subscribed: '1'
      };
      this.registerUser(this.payload, true);
    } else {
      this.util.checkValidForm(this.loginForm);
    }
  }

  registerUser(payload, step1) {
    this.isLoading = true;
    payload['g-recaptcha-response'] = this.loginForm.get('captcha').value;
    // delete payload['email'];
    this.auth.register(payload, true, step1).subscribe((res: any) => {
      if (step1 && res.data === 'Success') {
        this.step = 'step_2';
        this.donor = 'fresh';
        this.resetCaptcha();
        this.resizeDialoge();
        return false;
      }
      this.auth.userLogin(res.data).then((user) => {
        this.followCampaign(user.id);
        this.signupService.afterLogin(res);
      });
    }, (err) => {
      // if user is already exist
      if (err && err.status === 422) {
        this.step = 'step_2';
        this.donor = 'repeat';
        this.resizeDialoge();
      }
      this.resetCaptcha();
    });
  }

  resizeDialoge() {
    if (this.type === 'dialog') {
      this.dialogRef.updateSize('544px', '444px');
    }
  }

  /**Verify the firebase token from our api */
  verifyUserToken(payload) {
    this.auth.loginOTPVerify(payload).subscribe((res: any) => {
      this.auth.userLogin(res.data).then((user) => {
        this.followCampaign(user.id);
        this.signupService.afterLogin(res);
      });
    }, (error) => {
      this.isLoading = false;
      this.util.openSnackBar(error.error.message, 'error');
    }
    );
  }

  /** OTP varification */
  getVerifiedToken = (res) => {
    if (res && this.donor === 'fresh') {
      this.payload['accessToken'] = res;
      this.registerUser(this.payload, false);
    } else {
      this.signupService.socialLoginToken.next(res);
      const socialPlatform = 'google';
      this.auth.loginEmailCheck(res, socialPlatform).subscribe(
        (resp1: any) => {
          this.auth.loginSocail(res, 'LOGIN_GOOGLE').subscribe((resp2: any) => {
            this.vars.loginType = resp1.data.user_exists ? 'signin' : 'signup';
            this.vars.loginMethod = socialPlatform;
            this.signupService.afterLogin(resp2);
            this.followCampaign(resp2.data.user.id);
          });
        },
        (error) => {
          this.signupService.socialSignInType.next(socialPlatform);
        }
      );
    }
  }
  getVerifiedUser = (res) => {
    if (res && this.donor === 'repeat') {
      const payload = {
        extension: this.payload.extension,
        phone: this.payload.phone_1,
        firebase_response: res.user,
      };
      this.payload['firebase_response'] = res.user;
      this.verifyUserToken(payload);
    }
  }

  followCampaign(userId) {
    this.isLoading = true;
    this.fundraiserService.campaignVisitTrack(this.fundraiser.id, userId, { source: 'follow' }).subscribe((res) => {
      this.isFollowed = true;
      this.isLoading = false;
      this.sheet.dismiss();
      this.dialog.closeAll();
      this.util.openSnackBar('You started following this campaign', 'success');
      this.events.sendSystemEvent({
        'eventName': 'follow_campaign_done',
        'info_3': 'impact',
        'page_name': this.vars.pageName,
        'event_type_id': this.vars.fundraiser.id
      }).subscribe(_ => _);
    }, (err) => {
      this.isLoading = false;
      this.sheet.dismiss();
      this.dialog.closeAll();
    });
  }

  resetCaptcha() {
    if (this.captchaRef) {
      this.captchaRef.resetCaptcha();
      this.captchaRef.executeCaptcha();
      this.loginForm.get('captcha').setValue('');
    }
  }

  initCaptcha() {
    if (this.captchaRef) {
      this.captchaRef.executeCaptcha();
    }
  }

  ngOnDestroy(): void {
    this.subs.forEach(s => s.unsubscribe());
  }

}
